import { __module as a } from "./ghl-ui.es1677.js";
import { i as d } from "./ghl-ui.es1541.js";
import { i as l } from "./ghl-ui.es1678.js";
import { t as m } from "./ghl-ui.es1631.js";
import { r as n } from "./ghl-ui.es1637.js";
(function(i, r) {
  var e = d.default;
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = f;
  var o = e(l), u = e(m), s = e(n);
  function f(t) {
    if ((0, s.default)(1, arguments), !(0, o.default)(t) && typeof t != "number")
      return !1;
    var p = (0, u.default)(t);
    return !isNaN(Number(p));
  }
  i.exports = r.default;
})(a, a.exports);
var c = a.exports;
export {
  c as i
};
